// 發票核對與付款處理系統資料模型
// Invoice Verification & Payment Processing System Data Model

// 發票記錄
export const invoiceRecords = [
  {
    id: 'inv-2025-001',
    invoice_number: 'INV-2025-001',
    supplier_invoice_number: 'SUP-INV-001',
    po_id: 'po-2025-001',
    po_number: 'PO-2025-001',
    supplier_id: 'sup-001',
    supplier_name: '東亞電子科技股份有限公司',
    invoice_date: '2025-01-21T00:00:00',
    received_date: '2025-01-22T10:30:00',
    due_date: '2025-02-20T23:59:59',
    status: 'verified',
    verification_status: 'approved',
    payment_status: 'paid',
    currency: 'TWD',
    subtotal: 147500,
    tax_amount: 7375,
    total_amount: 154875,
    payment_terms: 'net30',
    items: [
      {
        id: 'inv-item-001',
        po_item_id: 'po-item-001',
        product_id: 'prod-001',
        product_name: '鋁合金材料 A-grade',
        quantity: 2950,
        unit: '公斤',
        unit_price: 50,
        line_total: 147500,
        tax_rate: 0.05,
        tax_amount: 7375,
        description: '鋁合金材料 A-grade',
        receiving_id: 'rcv-2025-001'
      }
    ],
    verification_details: {
      verified_by: '張會計',
      verified_at: '2025-01-22T14:30:00',
      po_match: true,
      receiving_match: true,
      price_match: true,
      quantity_match: false,
      quantity_variance: -50,
      variance_reason: '收貨數量短缺',
      variance_approved: true,
      approved_by: '財務主管',
      approved_at: '2025-01-22T16:00:00'
    },
    payment_details: {
      payment_id: 'pay-2025-001',
      payment_date: '2025-02-18T00:00:00',
      payment_method: 'bank_transfer',
      payment_amount: 154875,
      bank_account: '024-123456-001',
      reference_number: 'REF-2025-001',
      processed_by: '李出納'
    },
    documents: [
      {
        id: 'inv-doc-001',
        type: 'invoice',
        file_name: '發票_INV-2025-001.pdf',
        uploaded_at: '2025-01-22T10:45:00'
      },
      {
        id: 'inv-doc-002',
        type: 'payment_voucher',
        file_name: '付款憑證_PAY-2025-001.pdf',
        uploaded_at: '2025-02-18T14:30:00'
      }
    ],
    notes: '數量差異已獲核准，按實際收貨數量付款',
    created_at: '2025-01-22T10:30:00',
    updated_at: '2025-02-18T14:30:00'
  },
  {
    id: 'inv-2025-002',
    invoice_number: 'INV-2025-002',
    supplier_invoice_number: 'SUP-INV-002',
    po_id: 'po-2025-002',
    po_number: 'PO-2025-002',
    supplier_id: 'sup-002',
    supplier_name: '華南機械製造有限公司',
    invoice_date: '2025-01-23T00:00:00',
    received_date: '2025-01-24T09:15:00',
    due_date: '2025-03-09T23:59:59',
    status: 'pending_verification',
    verification_status: 'pending',
    payment_status: 'pending',
    currency: 'TWD',
    subtotal: 60000,
    tax_amount: 3000,
    total_amount: 63000,
    payment_terms: 'net45',
    items: [
      {
        id: 'inv-item-002',
        po_item_id: 'po-item-002',
        product_id: 'prod-002',
        product_name: '精密機械零件',
        quantity: 500,
        unit: '個',
        unit_price: 120,
        line_total: 60000,
        tax_rate: 0.05,
        tax_amount: 3000,
        description: '精密機械零件',
        receiving_id: 'rcv-2025-002'
      }
    ],
    verification_details: {
      verified_by: null,
      verified_at: null,
      po_match: true,
      receiving_match: false,
      price_match: true,
      quantity_match: true,
      quantity_variance: 0,
      variance_reason: null,
      variance_approved: null,
      approved_by: null,
      approved_at: null
    },
    payment_details: null,
    documents: [
      {
        id: 'inv-doc-003',
        type: 'invoice',
        file_name: '發票_INV-2025-002.pdf',
        uploaded_at: '2025-01-24T09:30:00'
      }
    ],
    notes: '待收貨完成後進行核對',
    created_at: '2025-01-24T09:15:00',
    updated_at: '2025-01-24T09:30:00'
  },
  {
    id: 'inv-2025-003',
    invoice_number: 'INV-2025-003',
    supplier_invoice_number: 'SUP-INV-003',
    po_id: 'po-2025-003',
    po_number: 'PO-2025-003',
    supplier_id: 'sup-004',
    supplier_name: '新科技材料研發股份有限公司',
    invoice_date: '2025-01-19T00:00:00',
    received_date: '2025-01-20T11:00:00',
    due_date: '2025-03-19T23:59:59',
    status: 'rejected',
    verification_status: 'rejected',
    payment_status: 'cancelled',
    currency: 'TWD',
    subtotal: 85000,
    tax_amount: 4250,
    total_amount: 89250,
    payment_terms: 'net60',
    items: [
      {
        id: 'inv-item-003',
        po_item_id: 'po-item-003',
        product_id: 'prod-003',
        product_name: '高分子材料',
        quantity: 1000,
        unit: '公斤',
        unit_price: 85,
        line_total: 85000,
        tax_rate: 0.05,
        tax_amount: 4250,
        description: '高分子材料',
        receiving_id: 'rcv-2025-003'
      }
    ],
    verification_details: {
      verified_by: '王會計',
      verified_at: '2025-01-20T15:30:00',
      po_match: true,
      receiving_match: false,
      price_match: true,
      quantity_match: true,
      quantity_variance: 0,
      variance_reason: '貨物品質檢驗不合格已退回',
      variance_approved: false,
      approved_by: '財務主管',
      approved_at: '2025-01-20T16:30:00'
    },
    payment_details: null,
    documents: [
      {
        id: 'inv-doc-004',
        type: 'invoice',
        file_name: '發票_INV-2025-003.pdf',
        uploaded_at: '2025-01-20T11:15:00'
      },
      {
        id: 'inv-doc-005',
        type: 'rejection_notice',
        file_name: '發票拒付通知_REJ-2025-003.pdf',
        uploaded_at: '2025-01-20T16:45:00'
      }
    ],
    notes: '因貨物品質不合格已退回，發票拒付',
    created_at: '2025-01-20T11:00:00',
    updated_at: '2025-01-20T16:45:00'
  }
];

// 付款記錄
export const paymentRecords = [
  {
    id: 'pay-2025-001',
    payment_number: 'PAY-2025-001',
    invoice_id: 'inv-2025-001',
    invoice_number: 'INV-2025-001',
    supplier_id: 'sup-001',
    supplier_name: '東亞電子科技股份有限公司',
    payment_date: '2025-02-18T00:00:00',
    payment_method: 'bank_transfer',
    payment_amount: 154875,
    currency: 'TWD',
    bank_details: {
      bank_name: '台灣銀行',
      account_number: '024-123456-001',
      swift_code: 'BKTWTWTP',
      account_holder: '東亞電子科技股份有限公司'
    },
    transaction_details: {
      reference_number: 'REF-2025-001',
      transaction_id: 'TXN-20250218-001',
      processing_fee: 50,
      exchange_rate: 1.0,
      net_amount: 154825
    },
    status: 'completed',
    processed_by: '李出納',
    processed_at: '2025-02-18T14:30:00',
    approved_by: '財務主管',
    approved_at: '2025-02-18T11:00:00',
    journal_entry_id: 'je-2025-001',
    notes: '準時付款，享有2%早付折扣',
    created_at: '2025-02-18T14:30:00',
    updated_at: '2025-02-18T14:30:00'
  },
  {
    id: 'pay-2025-002',
    payment_number: 'PAY-2025-002',
    invoice_id: 'inv-2024-050',
    invoice_number: 'INV-2024-050',
    supplier_id: 'sup-003',
    supplier_name: '環球物流供應鏈股份有限公司',
    payment_date: '2025-01-15T00:00:00',
    payment_method: 'check',
    payment_amount: 125000,
    currency: 'TWD',
    bank_details: {
      bank_name: '合作金庫',
      account_number: '345-678-901',
      swift_code: 'TCBKTWTP',
      account_holder: '環球物流供應鏈股份有限公司'
    },
    transaction_details: {
      reference_number: 'CHK-2025-001',
      check_number: 'CHK-001234',
      processing_fee: 0,
      exchange_rate: 1.0,
      net_amount: 125000
    },
    status: 'completed',
    processed_by: '陳出納',
    processed_at: '2025-01-15T16:00:00',
    approved_by: '財務主管',
    approved_at: '2025-01-15T14:30:00',
    journal_entry_id: 'je-2025-002',
    notes: '支票付款',
    created_at: '2025-01-15T16:00:00',
    updated_at: '2025-01-15T16:00:00'
  }
];

// 應付帳款摘要
export const accountsPayableSummary = {
  current_period: {
    total_outstanding: 2850000,
    overdue_amount: 125000,
    current_due: 850000,
    future_due: 1875000,
    total_invoices: 45,
    overdue_invoices: 3,
    paid_this_month: 1250000,
    average_payment_days: 28.5
  },
  aging_analysis: [
    { period: '未到期', amount: 1875000, count: 32, percentage: 65.8 },
    { period: '1-30天', amount: 650000, count: 8, percentage: 22.8 },
    { period: '31-60天', amount: 200000, count: 3, percentage: 7.0 },
    { period: '61-90天', amount: 100000, count: 1, percentage: 3.5 },
    { period: '90天以上', amount: 25000, count: 1, percentage: 0.9 }
  ],
  supplier_breakdown: [
    {
      supplier_id: 'sup-001',
      supplier_name: '東亞電子科技股份有限公司',
      outstanding_amount: 0,
      overdue_amount: 0,
      next_payment_date: null,
      payment_terms: 'net30'
    },
    {
      supplier_id: 'sup-002',
      supplier_name: '華南機械製造有限公司',
      outstanding_amount: 630000,
      overdue_amount: 0,
      next_payment_date: '2025-03-09',
      payment_terms: 'net45'
    },
    {
      supplier_id: 'sup-003',
      supplier_name: '環球物流供應鏈股份有限公司',
      outstanding_amount: 285000,
      overdue_amount: 25000,
      next_payment_date: '2025-02-15',
      payment_terms: 'net30'
    },
    {
      supplier_id: 'sup-004',
      supplier_name: '新科技材料研發股份有限公司',
      outstanding_amount: 1200000,
      overdue_amount: 0,
      next_payment_date: '2025-03-15',
      payment_terms: 'net60'
    },
    {
      supplier_id: 'sup-005',
      supplier_name: '精密工業設備有限公司',
      outstanding_amount: 735000,
      overdue_amount: 100000,
      next_payment_date: '2025-02-28',
      payment_terms: 'net30'
    }
  ]
};

// 付款處理儀表板資料
export const paymentProcessingDashboard = {
  summary: {
    pending_payments: 12,
    scheduled_payments: 8,
    completed_payments: 156,
    total_payment_amount: 12750000,
    avg_processing_time: 1.2,
    payment_accuracy: 99.8,
    early_payment_discount: 125000,
    late_payment_penalties: 8500
  },
  upcoming_payments: [
    {
      id: 'pay-upcoming-001',
      invoice_number: 'INV-2025-004',
      supplier_name: '華南機械製造有限公司',
      due_date: '2025-03-09',
      amount: 630000,
      payment_method: 'bank_transfer',
      priority: 'normal',
      early_discount_available: true,
      discount_amount: 12600,
      discount_deadline: '2025-03-02'
    },
    {
      id: 'pay-upcoming-002',
      invoice_number: 'INV-2025-005',
      supplier_name: '環球物流供應鏈股份有限公司',
      due_date: '2025-02-15',
      amount: 285000,
      payment_method: 'check',
      priority: 'high',
      early_discount_available: false,
      discount_amount: 0,
      discount_deadline: null
    }
  ],
  recent_payments: [
    {
      id: 'pay-2025-001',
      payment_number: 'PAY-2025-001',
      supplier_name: '東亞電子科技股份有限公司',
      payment_date: '2025-02-18',
      amount: 154875,
      status: 'completed',
      payment_method: 'bank_transfer'
    },
    {
      id: 'pay-2025-002',
      payment_number: 'PAY-2025-002',
      supplier_name: '環球物流供應鏈股份有限公司',
      payment_date: '2025-01-15',
      amount: 125000,
      status: 'completed',
      payment_method: 'check'
    }
  ],
  payment_trends: {
    monthly_payments: [
      { month: '2024-07', amount: 980000, count: 15 },
      { month: '2024-08', amount: 1120000, count: 18 },
      { month: '2024-09', amount: 950000, count: 14 },
      { month: '2024-10', amount: 1350000, count: 22 },
      { month: '2024-11', amount: 1180000, count: 19 },
      { month: '2024-12', amount: 1450000, count: 25 }
    ],
    payment_methods: [
      { method: 'bank_transfer', amount: 8500000, count: 112, percentage: 66.7 },
      { method: 'check', amount: 2850000, count: 28, percentage: 22.4 },
      { method: 'wire_transfer', amount: 1200000, count: 12, percentage: 9.4 },
      { method: 'cash', amount: 200000, count: 4, percentage: 1.5 }
    ]
  },
  approval_workflow: [
    {
      id: 'approval-001',
      invoice_number: 'INV-2025-006',
      supplier_name: '新科技材料研發股份有限公司',
      amount: 450000,
      submitted_by: '張會計',
      submitted_at: '2025-01-23T10:30:00',
      current_approver: '財務主管',
      status: 'pending_approval',
      approval_level: 2,
      total_levels: 3
    },
    {
      id: 'approval-002',
      invoice_number: 'INV-2025-007',
      supplier_name: '精密工業設備有限公司',
      amount: 850000,
      submitted_by: '李會計',
      submitted_at: '2025-01-24T14:15:00',
      current_approver: '總經理',
      status: 'pending_approval',
      approval_level: 3,
      total_levels: 3
    }
  ]
};

// 會計分錄記錄
export const journalEntries = [
  {
    id: 'je-2025-001',
    entry_number: 'JE-2025-001',
    payment_id: 'pay-2025-001',
    invoice_id: 'inv-2025-001',
    entry_date: '2025-02-18T00:00:00',
    description: '支付東亞電子科技採購款',
    reference: 'PAY-2025-001',
    total_debit: 154875,
    total_credit: 154875,
    entries: [
      {
        account_code: '2100',
        account_name: '應付帳款',
        debit: 154875,
        credit: 0,
        description: '支付供應商款項'
      },
      {
        account_code: '1100',
        account_name: '銀行存款',
        debit: 0,
        credit: 154825,
        description: '銀行轉帳付款'
      },
      {
        account_code: '6200',
        account_name: '銀行手續費',
        debit: 0,
        credit: 50,
        description: '轉帳手續費'
      }
    ],
    created_by: '李出納',
    created_at: '2025-02-18T14:30:00',
    posted: true,
    posted_by: '財務主管',
    posted_at: '2025-02-18T16:00:00'
  },
  {
    id: 'je-2025-002',
    entry_number: 'JE-2025-002',
    payment_id: 'pay-2025-002',
    invoice_id: 'inv-2024-050',
    entry_date: '2025-01-15T00:00:00',
    description: '支付環球物流採購款',
    reference: 'PAY-2025-002',
    total_debit: 125000,
    total_credit: 125000,
    entries: [
      {
        account_code: '2100',
        account_name: '應付帳款',
        debit: 125000,
        credit: 0,
        description: '支付供應商款項'
      },
      {
        account_code: '1100',
        account_name: '銀行存款',
        debit: 0,
        credit: 125000,
        description: '支票付款'
      }
    ],
    created_by: '陳出納',
    created_at: '2025-01-15T16:00:00',
    posted: true,
    posted_by: '財務主管',
    posted_at: '2025-01-15T17:00:00'
  }
];

// 發票核對規則
export const verificationRules = [
  {
    id: 'rule-001',
    name: '三方核對',
    description: '發票、採購訂單、收貨單三方核對',
    enabled: true,
    rules: [
      {
        field: 'supplier_id',
        condition: 'must_match',
        description: '供應商必須一致'
      },
      {
        field: 'total_amount',
        condition: 'tolerance',
        tolerance: 0.01,
        description: '總金額容差1%'
      },
      {
        field: 'quantity',
        condition: 'tolerance',
        tolerance: 0.05,
        description: '數量容差5%'
      },
      {
        field: 'unit_price',
        condition: 'must_match',
        description: '單價必須一致'
      }
    ]
  },
  {
    id: 'rule-002',
    name: '核准權限',
    description: '付款核准權限控制',
    enabled: true,
    approval_levels: [
      {
        level: 1,
        amount_limit: 100000,
        approver_role: '會計主管',
        required: true
      },
      {
        level: 2,
        amount_limit: 500000,
        approver_role: '財務主管',
        required: true
      },
      {
        level: 3,
        amount_limit: 999999999,
        approver_role: '總經理',
        required: true
      }
    ]
  }
];

export default {
  invoiceRecords,
  paymentRecords,
  accountsPayableSummary,
  paymentProcessingDashboard,
  journalEntries,
  verificationRules
}; 